import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "menu__body" }
const _hoisted_3 = { class: "menu__item" }
const _hoisted_4 = { class: "menu__item" }
const _hoisted_5 = { class: "menu__item" }
const _hoisted_6 = { class: "menu__item" }

import "./Menu.scss";
import Icon from "@/components/Icon/Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("menu", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          class: "menu__link",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { name: "home" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          class: "menu__link",
          to: "/wallet"
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { name: "wallet" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_RouterLink, {
          class: "menu__link",
          to: "/analytic"
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { name: "analytic" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_RouterLink, {
          class: "menu__link",
          to: "/settings"
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { name: "support" })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})